import { DEFAULT_MENU_PROPS } from 'ui/components/form-components-v2/select-v2/selectV2.configs'

/* The severity list matches the field's width and shows the design's five 42px
 * rows plus the search and reset rows before it scrolls. */
export const SEVERITY_MENU_PROPS = {
  ...DEFAULT_MENU_PROPS,
  PaperProps: {
    ...DEFAULT_MENU_PROPS.PaperProps,
    style: {
      maxHeight: 310,
      borderRadius: DEFAULT_MENU_PROPS.PaperProps.style.borderRadius
    }
  }
}
